import { ITurnos } from './turnos.interface';

export class Turnos {
    public domiciliosAddGruposProductosContenidoDescuentoInventarioUuid: string;
    public companiasId: number;
    public clientesId: number;
    public usuariosId: number;
    public estado: string;
    public turno: number;
    public cantidad: number;
    public fecha: string;
    public domicilio: boolean;
    public codigo: string;
    public numeroPedido: number;
    public fechaInicio: string;
    public fechaFin: string;
    public fechaSelect: boolean;
    public gruposReservasPorProductoId:string;
    public mesasId: number;
    public productosElaboradosId:string;
    public nombre:string;
    public valorImpuesto: number;
    public valorProducto: number;
    public porcentajeImpuesto: number;
    constructor(data: ITurnos) {
        this.domiciliosAddGruposProductosContenidoDescuentoInventarioUuid = data && data.domiciliosAddGruposProductosContenidoDescuentoInventarioUuid || null;
        this.companiasId = data && data.companiasId || null;
        this.clientesId = data && data.clientesId || null;
        this.usuariosId = data && data.usuariosId || null;
        this.estado = data && data.estado || null;
        this.turno = data && data.turno || null;
        this.cantidad = data && data.cantidad || null;
        this.fecha = data && data.fecha || null;
        this.domicilio = data && data.domicilio || null;
        this.codigo = data && data.codigo || null;
        this.numeroPedido = data && data.numeroPedido || null;
        this.fechaInicio = data && data.fechaInicio || null;
        this.fechaFin = data && data.fechaFin || null;
        this.fechaSelect = data && data.fechaSelect || null;
        this.gruposReservasPorProductoId = data && data.gruposReservasPorProductoId || null;
        this.mesasId = data && data.mesasId || null;
        this.productosElaboradosId = data && data.productosElaboradosId || null;
        this.nombre = data && data.nombre || null;
        this.valorImpuesto = data && data.valorImpuesto || null;
        this.valorProducto = data && data.valorProducto || null;
        this.porcentajeImpuesto = data && data.porcentajeImpuesto || null;
      }
  }




// WEBPACK FOOTER //
// ./src/models/turnos/turnos.models.ts